import type { IEpisode } from "@src/types/AppTypes";
import { createContext } from "react";

export const EpisodesContext = createContext<{
  episodes: { [key: number]: IEpisode[] };
  setEpisodes: React.Dispatch<
    | {
        payload: { [key: number]: IEpisode[] };
        type: "updateEpisodes";
      }
    | {
        payload: { [key: number]: IEpisode[] };
        type: "appendSeason";
      }
  >;
}>({ episodes: {}, setEpisodes: () => {} });

export function episodesReducer(
  state: { [key: number]: IEpisode[] },
  action:
    | { payload: { [key: number]: IEpisode[] }; type: "updateEpisodes" }
    | { payload: { [key: number]: IEpisode[] }; type: "appendSeason" }
) {
  if (action.type === "updateEpisodes") {
    return action.payload;
  } else if (action.type === "appendSeason") {
    return { ...state, ...action.payload };
  } else {
    return state;
  }
}
